import React from 'react';
import './loader.css';

const Loader = () => {
    return (
        <div className="reverse-spinner " >

        </div>
    );
};

export default Loader;